import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.concat.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//

import DetailBlock from "./DetailBlock";
import { webpReplaceProtocol } from "@/utils/imgResouruceError/index.js";
import URL from 'drip/utils/url';
var forceHundredPerReg = /(<img[^>]+style="[^"]*)(?=")/g;
var allWebpImgSrcReg = /(<img[^>]+src=")([^"]*.webp)"/gi;
var alltImgSrcReg = /<img.*?src="(.*?)".*?\/?>/gi;
export default {
  name: "detail-richtext",
  components: {
    DetailBlock: DetailBlock
  },
  props: {
    title: String,
    ricktext: String,
    seatUrl: String,
    isCategory: Boolean,
    showPoliceNotice: Boolean
  },
  data: function data() {
    return {
      filterRicktext: null
    };
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var fliterResult;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            fliterResult = _this.imgLoadingFailed(_this.ricktext);
            _context.next = 3;
            return _this.compatibleWebp(fliterResult);
          case 3:
            fliterResult = _context.sent;
            if (fliterResult) {
              _this.filterRicktext = fliterResult;
            }
            setTimeout(function () {
              _this.replaceImgFromRichText();
            }, 1000);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  computed: {
    formatedArticle: function formatedArticle() {
      // 将图片限制在屏幕内
      if (!this.filterRicktext) return;
      return this.filterRicktext.replace(forceHundredPerReg, "$1;width:100%; height: auto;");
    }
  },
  methods: {
    replaceImgFromRichText: function replaceImgFromRichText() {
      try {
        // 当前页面顶部海报图的img
        var basicImg = document.querySelectorAll('.lazyimage img')[0];
        if (basicImg) {
          document.querySelectorAll('.content_richtext img').forEach(function (img) {
            img.classList.add('poster');
            img.setAttribute('preview', '1');
            img.setAttribute('height', 'auto');
            img.setAttribute('large', img.src);
            img.setAttribute('previewText', '点击查看大图');
            img.onclick = basicImg.onclick;
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    /*解决APP容器内webp图片显示问题 */compatibleWebp: function compatibleWebp(data) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var webpReg, webpPromise, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              webpReg = new RegExp(/<img[^>]+src="([^"]*.webp)"/);
              webpPromise = []; // 匹配需要转换的webp图片
              result = data.match(allWebpImgSrcReg);
              if (!(!result || Array.isArray(result) && result.length <= 0)) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", Promise.resolve(data));
            case 5:
              result.map(function (item) {
                if (webpReg.test(item)) {
                  webpPromise.push(webpReplaceProtocol(RegExp.$1));
                }
              });

              // 拿到所有转换后的结果,准备替换webp格式的img src
              return _context2.abrupt("return", Promise.all(webpPromise).then(function (res) {
                var index = -1;
                var fliterResult = _this2.ricktext.replace(allWebpImgSrcReg, function (_, val2) {
                  index += 1;
                  return val2 + res[index] + '"';
                });
                return fliterResult;
              }).catch(function (err) {
                console.warn(err);
              }));
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    /**
     * 缩放后图片长、宽均大于2500的图片，美团裁剪不与处理
     * 任意一边缩放后仍旧大于16363不予处理
     * @param {object} query
     * @param {string} query.w 图片宽度
     * @param {string} query.h 图片宽度
     * @returns {number} 返回裁剪尺寸
     */
    dealMaxSize: function dealMaxSize(query) {
      var defaultSize = 750;
      var _URL$parseQuery = URL.parseQuery(query),
        w = _URL$parseQuery.w,
        h = _URL$parseQuery.h;
      var width = Number(w);
      var height = Number(h);
      if (isNaN(height) || isNaN(width)) {
        return defaultSize;
      }
      var _ref = height > width ? [height, width] : [width, height],
        _ref2 = _slicedToArray(_ref, 2),
        maxVal = _ref2[0],
        minVal = _ref2[1];
      var ratio = maxVal / 16363;
      // 本身尺寸小于边界值，直接裁剪到750
      if (ratio < 1) {
        return defaultSize;
      }
      // 缩小后的值
      var size = minVal / ratio;
      if (size >= 750) {
        return defaultSize;
      }
      // 取整裁剪
      return Math.floor(size / 10) * 10;
    },
    /* 解决图片url不正确问题 ,如果不是http、https协议、base64就清除这个img*/imgLoadingFailed: function imgLoadingFailed(data) {
      var _that = this;
      var fliterResult = data.replace(alltImgSrcReg, function (val1, val2) {
        var reg = /^(http|https|data)\S*/;
        if (reg.test(val2)) {
          var _val2$split = val2.split('?'),
            _val2$split2 = _slicedToArray(_val2$split, 2),
            url = _val2$split2[0],
            query = _val2$split2[1];
          // 计算裁剪尺寸
          var size = _that.dealMaxSize(query);
          // 处理上传至腾讯云的图片
          var cosRegex = /imageMogr2\/thumbnail\//;
          if (val2.indexOf('pipi.cn') > -1 && cosRegex.test(val2)) {
            return val1;
          }
          return val1.replace(val2, _that.imgFilters(url, size));
        } else {
          return "";
        }
      });
      return fliterResult;
    },
    // 美团云图片强制宽度750进行缩略处理
    imgFilters: function imgFilters(url) {
      var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 750;
      // png裁剪有异常
      if (/meituan.net/.test(url) && !/(\.(gif|png)){1}$/.test(url)) {
        return "".concat(url, "@").concat(size, "w");
      }
      return url;
    },
    handleCLickTip: function handleCLickTip() {
      Drip.redirect('https://cube.meituan.com/cube/block/6577939978c2/342960/index.html');
    }
  }
};